// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const EmailTemplateService = {
  getEmailTemplate: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/email-templates/`, {
      params,
      loader,
    }),

  getEmailTemplateTags: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/email-templates-tags/`, {
      params,
      loader,
    }),

  createEmailTemplate: (body) =>
    axios.post(`${BASE_URL}/email-templates/`, body),

  updateEmailTemplate: ({ body, params }) =>
    axios.put(`${BASE_URL}/email-templates-detail/`, body, {
      params,
    }),

  removeEmailTemplate: (params) =>
    axios.delete(`${BASE_URL}/email-templates-detail/`, {
      params,
    }),

  getSingleEmailTemplate: (params, loader = true) =>
    axios.get(`${BASE_URL}/email-templates-detail/`, {
      params,
      loader,
    }),

  getEmailTemplateFilterOptions: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/email-templates/filter-options`, {
      params,
      loader,
    }),

  filterEmailTemplates: (params = {}, loader = true) =>
    axios.get(`${BASE_URL}/email-templates/filter`, {
      params,
      loader,
    }),

  exportEmailTemplates: (body) =>
    axios.post(`${BASE_URL}/email-templates/export`, body, {
      responseType: 'arraybuffer',
    }),
};
